import NewUser from "layouts/pages/users/new-user";
import Timeline from "layouts/pages/projects/timeline";
import Widgets from "layouts/pages/widgets";
import RTL from "layouts/pages/rtl";
import Charts from "layouts/pages/charts";
import Notifications from "layouts/pages/notifications";
import Kanban from "layouts/applications/kanban";
import Wizard from "layouts/applications/wizard";
import DataTables from "layouts/applications/data-tables";
import Calendar from "layouts/applications/calendar";
import NewProduct from "layouts/ecommerce/products/new-product";
import EditProduct from "layouts/ecommerce/products/edit-product";
import ProductPage from "layouts/ecommerce/products/product-page";
import OrderList from "layouts/ecommerce/orders/order-list";
import OrderDetails from "layouts/ecommerce/orders/order-details";
// Material Dashboard 3 PRO React components
import MDAvatar from "components/MDAvatar";
// @mui icons
import Icon from "@mui/material/Icon";
// Images
import profilePicture from "assets/images/team-3.jpg";
import Basic from "layouts/authentication/sign-in/basic";
import AnalyticCharts from "layouts/pages/analytics";

import MyDashboardPage from "layouts/dashboards/MyDashboard";
import FinancialDashboard from "layouts/dashboards/FinancialDashboard";
import CommercialDashboard from "layouts/dashboards/commercialDashboard";
import OperationsDashboard from "layouts/dashboards/OperationsDashboard";
import TechnologyDashboard from "layouts/dashboards/TechnologyDashboard";
import MarketingDashboard from "layouts/dashboards/MarketingDashboard";
import HumanResources from "layouts/dashboards/HumanResourcesDashboard";
import Retails from "layouts/dashboards/RetailsNetwork";
import RetailsDetailspage from "layouts/dashboards/RetailsNetwork/RetailsDetails";
import Distributors from "layouts/dashboards/DistributorNetwork";
import DistributorsDetailspage from "layouts/dashboards/DistributorNetwork/DistributorsDetails";
import CommercialInsights from"layouts/dashboards/CommercialInsights";
import Intelligence from "layouts/dashboards/Intelligence";
import ProtectedRoute from "components/ProtectedRoute";
const routes = [
  {
    type: "collapse",
    name: "Brooklyn Alice",
    key: "brooklyn-alice",
    icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
    collapse: [
      // {
      //   name: "My Profile",
      //   key: "my-profile",
      //   route: "/pages/profile/profile-overview",
      //   component: <ProfileOverview />,
      // },
      {
        name: "Logout",
        key: "logout",
        route: "/authentication/sign-in/basic",
        component: <Basic />,
      },
    ],
  },

  { type: "divider", key: "divider-0" },

  // { type: "title", title: "Our Doors", key: "title-pages" },
  {
    type: "collapse",
    name: "Our Doors",
    key: "our-doors",
    icon: <Icon fontSize="small">store</Icon>,
    collapse: [
      {
        name: "Accounts",
        key: "Accounts",
        route: "/pages/accounts",
        component: <ProtectedRoute><RTL /></ProtectedRoute>
      },
    ],
  },
  {
    type: "collapse",
    name: "Operations",
    key: "operations",
    icon: <Icon fontSize="small">settings</Icon>,
    collapse: [
      {
        name: "Recap",
        key: "recap",
        route: "/applications/kanban",
        component: <Kanban />,
      },
      {
        name: "Directives",
        key: "directives",
        route: "/applications/wizard",
        component: <Wizard />,
      },
      {
        name: "Visits",
        key: "visits",
        route: "/applications/data-tables",
        component: <DataTables />,
      },
      {
        name: "Calendar",
        key: "calendar",
        route: "/applications/calendar",
        component: <Calendar />,
      },
      {
        name: "Store Development",
        key: "store-development",
        route: "/pages/charts",
        component: <Charts />,
      },
      {
        name: "Knowledge Exchange",
        key: "knowledge-exchange",
        route: "/pages/projects/timeline",
        component: <Timeline />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Intelligence",
    key: "intelligence",
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/intelligence",
    component: <ProtectedRoute><Intelligence /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Explorer",
    key: "explorer",
    icon: <Icon fontSize="small">search</Icon>,
    route: "/explorer",
    component: <ProtectedRoute><FinancialDashboard /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "route",
    name: "My Dashboard",
    key: "my-dashboard",
    route: "/dashboards/my-dashboard",
    component: <ProtectedRoute><MyDashboardPage /></ProtectedRoute>
  },
  {
    type: "route",
    name: "Financials",
    key: "financials",
    route: "/dashboards/financials",
    component: <ProtectedRoute><FinancialDashboard /></ProtectedRoute>
  },
  {
    type: "route",
    name: "Commercial",
    key: "commercial",
    route: "/dashboards/commercial",
    component: <ProtectedRoute><CommercialDashboard /></ProtectedRoute>
  },
  {
    type: "route",
    name: "Operations",
    key: "operations",
    route: "/dashboards/operations",
    component: <ProtectedRoute><OperationsDashboard /></ProtectedRoute>
  },

  {
    type: "route",
    name: "Technology",
    key: "technology",
    route: "/dashboards/technology",
    component: <ProtectedRoute><TechnologyDashboard /></ProtectedRoute>
  },
  {
    type: "route",
    name: "  Marketing",
    key: "marketing",
    route: "/dashboards/marketing",
    component: <ProtectedRoute><MarketingDashboard /></ProtectedRoute>
  },
  {
    type: "route",
    name: "  HumanResources",
    key: "humanResources",
    route: "/dashboards/human-resources",
    component: <ProtectedRoute><HumanResources /></ProtectedRoute>
  },
  {
    type: "route",
    name: "  Retailers",
    key: "retailers",
    route: "/network/retailers",
    component: <ProtectedRoute><Retails /></ProtectedRoute>
  },
   {
    type: "route",
    name: "  Retailers",
    key: "retailers",
    route: "/network/retailers/details",
    component: <ProtectedRoute><RetailsDetailspage /></ProtectedRoute>
  }
,
   {
    type: "route",
    name: "  Distributors",
    key: "distributors",
    route: "/network/distributors",
    component: <ProtectedRoute>< Distributors/></ProtectedRoute>
  }
  
,
 {
    type: "route",
    name: "  Distributors",
    key: "distributors",
    route: "/network/distributors/details",
    component: <ProtectedRoute><DistributorsDetailspage /></ProtectedRoute>
  },

   {
    type: "route",
    name: "Leadership",
    key: "leadership",
    route: "/insights/leadership",
    component: <ProtectedRoute></ProtectedRoute>
  },
  {
    type: "route",
    name: "Commercial",
    key: "commercial",
    route: "/insights/commercial",
    component: <ProtectedRoute>< CommercialInsights/></ProtectedRoute>
  },
  
  {
    type: "collapse",
    name: "User Management",
    key: "user-management",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/admin/user-management",
    component: <NewUser />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Admin/Setup",
    key: "admin-setup",
    icon: <Icon fontSize="small">build</Icon>,
    collapse: [
      {
        name: "User Mgmt.",
        key: "user-mgmt",
        route: "/ecommerce/products/new-product",
        component: <NewProduct />,
      },
      {
        name: "Account Mgmt.",
        key: "account-mgmt",
        route: "/ecommerce/products/edit-product",
        component: <EditProduct />,
      },
      {
        name: "Store Mgmt.",
        key: "store-mgmt",
        route: "/ecommerce/products/product-page",
        component: <ProductPage />,
      },
      {
        name: "Campaign Mgmt.",
        key: "Campaign-mgmt",
        route: "/ecommerce/products/product-page",
        component: <ProductPage />,
      },
      {
        name: "Upload Data",
        key: "upload-data",
        route: "/ecommerce/products/product-page",
        component: <ProductPage />,
      },
      {
        name: "Feature",
        key: "feature",
        route: "/ecommerce/orders/order-list",
        component: <OrderList />,
      },
      {
        name: "Access-Matrix",
        key: "access-matrix",
        route: "/ecommerce/orders/order-details",
        component: <OrderDetails />,
      },
    ],
  },
  //       {
  //         name: "Orders",
  //         key: "orders",
  //         collapse: [
  //           {
  //             name: "Order List",
  //             key: "order-list",
  //             route: "/ecommerce/orders/order-list",
  //             component: <OrderList />,
  //           },
  //           {
  //             name: "Order Details",
  //             key: "order-details",
  //             route: "/ecommerce/orders/order-details",
  //             component: <OrderDetails />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     type: "collapse",
  //     name: "Authentication",
  //     key: "authentication",
  //     icon: <Icon fontSize="small">content_paste</Icon>,
  //     collapse: [
  //       {
  //         name: "Sign In",
  //         key: "sign-in",
  //         collapse: [
  //           {
  //             name: "Basic",
  //             key: "basic",
  //             route: "/authentication/sign-in/basic",
  //             component: <SignInBasic />,
  //           },
  //           {
  //             name: "Cover",
  //             key: "cover",
  //             route: "/authentication/sign-in/cover",
  //             component: <SignInCover />,
  //           },
  //           {
  //             name: "Illustration",
  //             key: "illustration",
  //             route: "/authentication/sign-in/illustration",
  //             component: <SignInIllustration />,
  //           },
  //         ],
  //       },
  //       {
  //         name: "Sign Up",
  //         key: "sign-up",
  //         collapse: [
  //           {
  //             name: "Cover",
  //             key: "cover",
  //             route: "/authentication/sign-up/cover",
  //             component: <SignUpCover />,
  //           },
  //         ],
  //       },
  //       {
  //         name: "Reset Password",
  //         key: "reset-password",
  //         collapse: [
  //           {
  //             name: "Cover",
  //             key: "cover",
  //             route: "/authentication/reset-password/cover",
  //             component: <ResetCover />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   { type: "divider", key: "divider-1" },
  //   { type: "title", title: "Docs", key: "title-docs" },
  //   {
  //     type: "collapse",
  //     name: "Basic",
  //     key: "basic",
  //     icon: <Icon fontSize="small">upcoming</Icon>,
  //     collapse: [
  //       {
  //         name: "Getting Started",
  //         key: "getting-started",
  //         collapse: [
  //           {
  //             name: "Overview",
  //             key: "overview",
  //             href: "https://www.creative-tim.com/learning-lab/react/overview/material-dashboard/",
  //           },
  //           {
  //             name: "License",
  //             key: "license",
  //             href: "https://www.creative-tim.com/learning-lab/react/license/material-dashboard/",
  //           },
  //           {
  //             name: "Quick Start",
  //             key: "quick-start",
  //             href: "https://www.creative-tim.com/learning-lab/react/quick-start/material-dashboard/",
  //           },
  //           {
  //             name: "Build Tools",
  //             key: "build-tools",
  //             href: "https://www.creative-tim.com/learning-lab/react/build-tools/material-dashboard/",
  //           },
  //         ],
  //       },
  //       {
  //         name: "Foundation",
  //         key: "foundation",
  //         collapse: [
  //           {
  //             name: "Colors",
  //             key: "colors",
  //             href: "https://www.creative-tim.com/learning-lab/react/colors/material-dashboard/",
  //           },
  //           {
  //             name: "Grid",
  //             key: "grid",
  //             href: "https://www.creative-tim.com/learning-lab/react/grid/material-dashboard/",
  //           },
  //           {
  //             name: "Typography",
  //             key: "base-typography",
  //             href: "https://www.creative-tim.com/learning-lab/react/base-typography/material-dashboard/",
  //           },
  //           {
  //             name: "Borders",
  //             key: "borders",
  //             href: "https://www.creative-tim.com/learning-lab/react/borders/material-dashboard/",
  //           },
  //           {
  //             name: "Box Shadows",
  //             key: "box-shadows",
  //             href: "https://www.creative-tim.com/learning-lab/react/box-shadows/material-dashboard/",
  //           },
  //           {
  //             name: "Functions",
  //             key: "functions",
  //             href: "https://www.creative-tim.com/learning-lab/react/functions/material-dashboard/",
  //           },
  //           {
  //             name: "Routing System",
  //             key: "routing-system",
  //             href: "https://www.creative-tim.com/learning-lab/react/routing-system/material-dashboard/",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     type: "collapse",
  //     name: "Components",
  //     key: "components",
  //     icon: <Icon fontSize="small">view_in_ar</Icon>,
  //     collapse: [
  //       {
  //         name: "Alerts",
  //         key: "alerts",
  //         href: "https://www.creative-tim.com/learning-lab/react/alerts/material-dashboard/",
  //       },
  //       {
  //         name: "Avatar",
  //         key: "avatar",
  //         href: "https://www.creative-tim.com/learning-lab/react/avatar/material-dashboard/",
  //       },
  //       {
  //         name: "Badge",
  //         key: "badge",
  //         href: "https://www.creative-tim.com/learning-lab/react/badge/material-dashboard/",
  //       },
  //       {
  //         name: "Badge Dot",
  //         key: "badge-dot",
  //         href: "https://www.creative-tim.com/learning-lab/react/badge-dot/material-dashboard/",
  //       },
  //       {
  //         name: "Box",
  //         key: "box",
  //         href: "https://www.creative-tim.com/learning-lab/react/box/material-dashboard/",
  //       },
  //       {
  //         name: "Buttons",
  //         key: "buttons",
  //         href: "https://www.creative-tim.com/learning-lab/react/buttons/material-dashboard/",
  //       },
  //       {
  //         name: "Date Picker",
  //         key: "date-picker",
  //         href: "https://www.creative-tim.com/learning-lab/react/datepicker/material-dashboard/",
  //       },
  //       {
  //         name: "Dropzone",
  //         key: "dropzone",
  //         href: "https://www.creative-tim.com/learning-lab/react/dropzone/material-dashboard/",
  //       },
  //       {
  //         name: "Editor",
  //         key: "editor",
  //         href: "https://www.creative-tim.com/learning-lab/react/quill/material-dashboard/",
  //       },
  //       {
  //         name: "Input",
  //         key: "input",
  //         href: "https://www.creative-tim.com/learning-lab/react/input/material-dashboard/",
  //       },
  //       {
  //         name: "Pagination",
  //         key: "pagination",
  //         href: "https://www.creative-tim.com/learning-lab/react/pagination/material-dashboard/",
  //       },
  //       {
  //         name: "Progress",
  //         key: "progress",
  //         href: "https://www.creative-tim.com/learning-lab/react/progress/material-dashboard/",
  //       },
  //       {
  //         name: "Snackbar",
  //         key: "snackbar",
  //         href: "https://www.creative-tim.com/learning-lab/react/snackbar/material-dashboard/",
  //       },
  //       {
  //         name: "Social Button",
  //         key: "social-button",
  //         href: "https://www.creative-tim.com/learning-lab/react/social-buttons/material-dashboard/",
  //       },
  //       {
  //         name: "Typography",
  //         key: "typography",
  //         href: "https://www.creative-tim.com/learning-lab/react/typography/material-dashboard/",
  //       },
  //     ],
  //   },
  //   {
  //     type: "collapse",
  //     name: "Change Log",
  //     key: "changelog",
  //     href: "https://github.com/creativetimofficial/ct-material-dashboard-pro-react/blob/main/CHANGELOG.md",
  //     icon: <Icon fontSize="small">receipt_long</Icon>,
  //     noCollapse: true,
  //   },

  {
    type: "collapse",
    name: "Analytics",
    key: "Analytics",
    icon: <Icon fontSize="small">bolt</Icon>,
    // route: "/pages/analytics",
    route: "/dashboards/analytics",
    component: <ProtectedRoute><AnalyticCharts /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Competitive Analytics",
    key: "competitive-analytics",
    icon: <Icon fontSize="small">bolt</Icon>,
    route: "/dashboards/competitive-analytics",
    component: <ProtectedRoute><FinancialDashboard /></ProtectedRoute>,
    noCollapse: true,
  },
];

export default routes;
